<template>
<div>
    <table :id="id" class="table table-striped table-bordered w-100" :style="'font-size: '+this.dtFontSize+'px;'">
        <thead>
            <tr>
                <th v-for="(columna, k) in columnas" :key="k">
                    <i :class="columna.clase"></i> {{ columna.nombre }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(data, k) in datos_table" :key="k">
                <td v-for="(columna, j) in columnas" :key="j">
                    <slot :name="columna.nombre_variable" v-if="columna.slot" v-bind:data="data">
                        <!-- {{data}} -->
                    </slot>
                    <div v-else>
                        <span>{{ data[columna.nombre_variable] }}</span>
                        <!-- {{}} -->
                    </div>
                </td>
            </tr>
        </tbody>

    </table>
</div>
</template>

<script>
const language_tables = "/inspinia/plugins/DataTables/i18n/Spanish.json"
export default {
    props: ['id', 'datos', 'columnas', 'responsive', 'fontSize'],
    data: function () {
        return {
            dtFontSize: 11,
            columnDetalles: false,
            datos_table: [],
            cont: 0,
        };
    },
    mounted() {
        this.dtFontSize = this.fontSize ?? 11;
        // setTimeout(() => {
        //     this.nuevo();

        // }, 500);
        // console.log("ASDASDAS");
    },
    destroyed() {

        $(`#${this.id}`).DataTable().clear().destroy()
    },
    methods: {
        nuevo() {
            $(`#${this.id}`).DataTable({
                destroy: true,
                responsive: this.responsive ?? true,
                language: { url: language_tables },
                dom: '<"row"<"col-sm-5"B><"col-sm-7"lf>>t<"row"<"col-sm-5"i><"col-sm-7"p>>',
                buttons: [{
                        extend: "colvis",
                        className: "btn-sm btn-gray",
                        text: '<i class="fa fa-filter"></i> Columnas visibles',
                    },
                    {
                        extend: "excel",
                        className: "btn-sm btn-gray",
                        text: '<i class="fa fa-file-excel"></i> Excel',
                        exportOptions: {
                            columns: ":not(.notexport)",
                        },
                    },
                    {
                        extend: "pdf",
                        className: "btn-sm btn-gray",
                        text: '<i class="fa fa-file-pdf"></i> PDF',
                        orientation: "landscape",
                        exportOptions: {
                            columns: ":not(.notexport)",
                        },
                    },
                ],
                order: [],
            });
        },
        destroy() {
            $(`#${this.id}`).DataTable().clear().destroy()
        }
    },
    watch: {
        datos() {
            if(this.cont > 0)
                this.destroy();
            this.cont++;
            this.datos_table = this.datos
            const _this = this;
            setTimeout( function () {
                _this.nuevo();
            }, 600 );
        }
    }
}
</script>

<style>
.dataTables_filter label {
    margin-right: 0px !important;
}
</style>
